import { render, staticRenderFns } from "./MediaShareSettingsDialog.vue?vue&type=template&id=7afe2a26"
import script from "./MediaShareSettingsDialog.vue?vue&type=script&lang=js"
export * from "./MediaShareSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports